import {
  Avatar,
  Flex,
  FlexProps,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  Stack,
  Tab,
} from "@chakra-ui/react";
import { useState } from "react";
import { HiOutlineLogout } from "react-icons/hi";

import { ClientWhiteLogo } from "../../assets/images/ClientLogo";
import { ClientBlackLogo } from "../../assets/images/ClientLogo";
import { Logo, VariantTypes } from "../../assets/images/Logo";
import { useAuth } from "../../hooks/useAuth";
import { TabName } from "../../utils/typings";
import { Show } from "../Show";
import icon from "../../assets/images/Logo/almond-icon.jpg";
import mctIcon from "../../assets/images/ClientLogo/mct-icon.png";

interface HeaderProps extends FlexProps {
  onTabChange: (tab: number) => void;
  currentTab?: any;
}

export const Header = ({ ...rest }: HeaderProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const { user, logout } = useAuth();

  const tabNames = Object.values(TabName) as TabName[];

  const renderTabs = (tabs: TabName[]) =>
    tabs.map((tab, index) => (
      <Tab
        // eslint-disable-next-line react-hooks/rules-of-hooks
        color={!rest?.currentTab || rest?.currentTab === 0 ? "white" : "black"}
        _selected={{ color: "#00AE42", borderColor: "#00AE42" }}
        paddingBottom="36px"
        onClick={() => rest.onTabChange(index)}
      >
        {tab}
      </Tab>
    ));

  const toggleMenu = () => {
    const currentMenuStatus = isMenuOpen;
    setIsMenuOpen(!currentMenuStatus);
  };

  return (
    <Flex
      as="nav"
      align="center"
      justify="space-between"
      w="full"
      maxW="full"
      mt="24px"
      borderBottom={
        !rest?.currentTab || rest?.currentTab === 0
          ? "1px solid rgba(255, 255, 255, 0.2)"
          : "1px solid rgba(0, 0, 0, 0.2)"
      }
      px={{ base: "4", lg: "40px" }}
      position="fixed"
      zIndex="3"
      {...rest}
    >
      <Show condition={user?.isAdmin}>
        <Flex align="center" justify="space-between" maxW="175px">
          {!rest?.currentTab || rest?.currentTab === 0 ? (
            <Logo variant={VariantTypes.white} />
          ) : (
            <Logo variant={VariantTypes.black} />
          )}
        </Flex>
      </Show>
      <Show condition={!user?.isAdmin}>
        <Flex align="center" justify="space-between" maxW="175px">
          {!rest?.currentTab || rest?.currentTab === 0 ? (
            <ClientWhiteLogo />
          ) : (
            <ClientBlackLogo />
          )}
        </Flex>
      </Show>

      <Flex align="center" justify="center" w="full" flexDirection="row">
        {renderTabs(tabNames)}
      </Flex>

      <Stack
        flexDirection="row"
        border={
          !rest?.currentTab || rest?.currentTab === 0
            ? "1px solid rgba(255, 255, 255, 0.2)"
            : "1px solid rgba(0, 0, 0, 0.2)"
        }
        p="5px 15px 5px 5px"
        borderRadius="80px"
        alignItems="center"
        marginBottom="28px"
        justifyContent="center"
        gap={3}
        _hover={{ cursor: "pointer" }}
        onClick={toggleMenu}
      >
        <Menu colorScheme="gray" isOpen={isMenuOpen}>
          <MenuButton
            aria-label="Options"
            as={Avatar}
            color={rest?.currentTab !== 0 ? "black" : "gray.400"}
            variant="ghost"
            colorScheme="gray"
            size="sm"
            src={user?.isAdmin ? icon : mctIcon}
          />
          <MenuList>
            <MenuItem icon={<HiOutlineLogout />} onClick={logout}>
              Logout
            </MenuItem>
          </MenuList>
        </Menu>
        <Text
          color={
            !rest?.currentTab || rest?.currentTab === 0 ? "white" : "black"
          }
        >
          {user?.fullName}
        </Text>
      </Stack>
    </Flex>
  );
};
